export default __webpack_public_path__ + "static/media/store-level-3.e49bf952.png";